import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type BuyerUpdatedToastProps = {
  toastId: string | number;
};

export const BuyerUpdatedToast: FC<BuyerUpdatedToastProps> = ({toastId}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('view.buyers.editBuyerModal.updatedToast.title')}
      description={t('view.buyers.editBuyerModal.updatedToast.description')}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.buyers.detail.toastClose')}
    />
  );
};

export function showBuyerUpdatedToast(): void {
  toast.custom(id => <BuyerUpdatedToast toastId={id} />, {duration: 10_000});
}
